<!--PERMET DE SÉLECTIONNER 2 OPTIONS DISTINCT-->
<template>
    <div id="s-upDownArrow">

        <span v-if="status == true"> 
            <b-icon icon="arrow-bar-up" font-scale="1" class="refreshColor"></b-icon>
        </span>
        <span v-else> 
            <b-icon icon="arrow-bar-down" font-scale="1" class="refreshColor"></b-icon>
        </span>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 's-upDownArrow',
    props: {
        status: Boolean,
    },
    data() {
        return {
            
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters([]),
    }
}
</script>

<style lang="scss" scoped>

</style>